<div class="user-type-picker-field">
    @if (label) {
        <div class="label-container">
            <cerrix-label [for]="name">{{ label }}</cerrix-label>
            @if (infoText) {
                <cerrix-instructions-icon
                    class="input-instructions-icon"
                    [instructionText]="infoText"
                    [showText]="false"
                ></cerrix-instructions-icon>
            }
        </div>
    }
    @if (types.length > 1) {
        <div class="type-selection">
            <app-cerrix-card-toggle-group
                [options]="cardOptions"
                [selectedValue]="activeType?.key"
                (selectedValueChange)="selectTypeByValue($event)"
            >
                <ng-template #cardContent let-option>
                    <app-cerrix-avatar-group
                        [names]="selectedNames(option.data)"
                        [showAddButton]="selectedNames(option.data).length === 0  || !readonly"
                    ></app-cerrix-avatar-group>
                </ng-template>
            </app-cerrix-card-toggle-group>
        </div>
    }
    @if (activeType; as type) {
        <div class="type-content">
            @if (type.multiselect) {
                <app-cerrix-user-picker
                    [name]="name + '-' + type.key"
                    [users]="type.users"
                    [multiselect]="true"
                    [values]="selectedValues[type.key]"
                    (valuesChange)="setSelectedUsers(type, $event)"
                    [readonly]="readonly"
                ></app-cerrix-user-picker>
            } @else {
                <app-cerrix-user-picker
                    [name]="name + '-' + type.key"
                    [users]="type.users"
                    [value]="singleValueFor(type)"
                    (valueChange)="setSingleValue(type, $event)"
                    [readonly]="readonly"
                ></app-cerrix-user-picker>
            }
        </div>
    }
</div>
